(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yeefine-buying-guide"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialized = new WeakSet();
  const initialize = () => {
    document.querySelectorAll('[data-yf-guide]').forEach(root => {
      if (initialized.has(root)) return;
      initialized.add(root);
      const body = root.querySelector('[data-yf-guide-body]');
      const content = root.querySelector('[data-yf-guide-content]');
      const faqHeading = [...body.querySelectorAll('h2,h3')].find(h => /\bfaq(?:s)?\b|frequently asked|common questions/i.test(h.textContent) && h.textContent.length < 120);
      if (faqHeading) {
        const level = Number(faqHeading.tagName.slice(1));
        const group = [];
        let next = faqHeading.nextElementSibling;
        while (next && !( /^H[1-6]$/.test(next.tagName) && Number(next.tagName.slice(1)) <= level)) {
          group.push(next);
          next = next.nextElementSibling;
        }
        const questions = group.filter(n => /^H[3-6]$/.test(n.tagName) || (n.tagName === 'P' && /[?？]$/.test(n.textContent.trim()) && n.textContent.trim().length < 220));
        if (root.querySelector('[data-yf-guide-faq]')) {
          faqHeading.hidden = true;
          group.forEach(n => n.hidden = true);
        } else if (questions.length && group[0] === questions[0]) {
          const panel = document.createElement('section');
          panel.className = 'yf-guide__faq';
          panel.dataset.yfGuideFaq = '';
          faqHeading.before(panel);
          panel.append(faqHeading);
          let details;
          let answer;
          group.forEach(node => {
            if (questions.includes(node)) {
              details = document.createElement('details');
              details.className = 'yf-guide__question';
              const summary = document.createElement('summary');
              const label = document.createElement('span');
              label.textContent = node.textContent;
              const icon = document.createElement('span');
              icon.className = 'yf-guide__plus';
              icon.setAttribute('aria-hidden','true');
              icon.textContent = '+';
              summary.append(label,icon);
              details.append(summary);
              answer = document.createElement('div');
              answer.className = 'yf-guide__answer';
              details.append(answer);
              panel.append(details);
              node.remove();
            } else if (answer) answer.append(node);
          });
        }
      }
      content.querySelectorAll('table').forEach(table => {
        if (table.closest('.yf-post__table-scroll')) return;
        const region = document.createElement('div');
        region.className = 'yf-post__table-scroll';
        region.tabIndex = 0;
        region.setAttribute('role','region');
        region.setAttribute('aria-label',content.dataset.tableLabel);
        table.before(region);
        region.append(table);
      });
      content.querySelectorAll('details').forEach(details => {
        details.addEventListener('toggle',() => {
          const icon = details.querySelector('summary .yf-guide__plus');
          if (icon) icon.textContent = details.open ? '−' : '+';
        });
      });
      const headings = [...content.querySelectorAll('h2,h3')].filter(h => !h.hidden && !h.closest('[hidden]') && !h.closest('.yf-guide__product-card') && !h.closest('.yf-guide__question'));
      const toc = root.querySelector('[data-yf-guide-toc]');
      if (toc && headings.length > 1) {
        const list = toc.querySelector('ol');
        headings.forEach((heading,index) => {
          if (!heading.id) heading.id = root.id + '-guide-section-' + (index + 1);
          const item = document.createElement('li');
          if (heading.tagName === 'H3') item.className = 'yf-post__toc-sub';
          const link = document.createElement('a');
          link.href = '#' + heading.id;
          link.textContent = heading.textContent.trim();
          item.append(link);
          list.append(item);
        });
        toc.hidden = false;
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initialize,{once:true});
  else initialize();
  document.addEventListener('shopify:section:load',initialize);
  window.addEventListener('pageshow',initialize);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yeefine-home-journal"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialized = new WeakMap();
  const initialize = () => {
    document.querySelectorAll('[data-yf-home-journal]').forEach(root => {
      if (initialized.has(root)) return;
      const controller = new AbortController();
      const listenerOptions = {signal:controller.signal};
      initialized.set(root,controller);
      const cards = [...root.querySelectorAll('[data-yf-hj-card]')];
      const filters = [...root.querySelectorAll('[data-yf-hj-filter]')];
      const desktopLimit = Number(root.dataset.limit) || 6;
      const mobileLimit = Number(root.dataset.mobileLimit) || 1;
      const mobile = window.matchMedia('(max-width:749px)');
      let limit = mobile.matches ? mobileLimit : desktopLimit;
      const grid = root.querySelector('.yf-home-journal__grid');
      const status = root.querySelector('[role="status"]');
      const pagination = root.querySelector('[data-yf-hj-pagination]');
      const pages = root.querySelector('[data-yf-hj-pages]');
      const previous = root.querySelector('[data-yf-hj-previous]');
      const next = root.querySelector('[data-yf-hj-next]');
      let selected = '', currentPage = 1, totalPages = 1;
      const render = (announce = true, focusPage = false) => {
        const matched = cards.filter(card => !selected || JSON.parse(card.dataset.tags).includes(selected));
        totalPages = Math.max(1,Math.ceil(matched.length / limit));
        currentPage = Math.min(currentPage,totalPages);
        cards.forEach(card => { card.hidden = true; });
        const visible = matched.slice((currentPage - 1) * limit,currentPage * limit);
        visible.forEach(card => { card.hidden = false; });
        pages.replaceChildren();
        for (let number = 1; number <= totalPages; number += 1) {
          const button = document.createElement('button');
          button.type = 'button';
          button.textContent = String(number);
          button.setAttribute('aria-label',pagination.dataset.pageLabel.replace('__PAGE__',String(number)));
          button.setAttribute('aria-controls',grid.id);
          if (number === currentPage) button.setAttribute('aria-current','page');
          button.addEventListener('click',() => { currentPage = number; render(true,true); },listenerOptions);
          pages.append(button);
        }
        previous.disabled = currentPage === 1;
        next.disabled = currentPage === totalPages;
        grid.scrollTo({left:0,behavior:'instant'});
        if (announce) status.textContent = root.dataset.results.replace('__COUNT__',String(visible.length));
        if (focusPage) pages.querySelector('[aria-current="page"]').focus({preventScroll:true});
      };
      filters.forEach(button => {
        button.addEventListener('click',() => {
          selected = button.dataset.yfHjFilter;
          currentPage = 1;
          filters.forEach(filter => {
            const active = filter === button;
            filter.classList.toggle('is-active',active);
            filter.setAttribute('aria-pressed',String(active));
          });
          render();
          button.scrollIntoView({block:'nearest',inline:'nearest',behavior:'instant'});
        },listenerOptions);
      });
      previous.addEventListener('click',() => { if (currentPage > 1) { currentPage -= 1; render(true,true); } },listenerOptions);
      next.addEventListener('click',() => { if (currentPage < totalPages) { currentPage += 1; render(true,true); } },listenerOptions);
      mobile.addEventListener('change',() => {
        limit = mobile.matches ? mobileLimit : desktopLimit;
        currentPage = 1;
        render(false);
      },listenerOptions);
      render(false);
      root.dataset.yfHjReady = 'true';
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initialize,{once:true});
  else initialize();
  document.addEventListener('shopify:section:load',initialize);
  document.addEventListener('shopify:section:unload',event => {
    event.target.querySelectorAll('[data-yf-home-journal]').forEach(root => {
      initialized.get(root)?.abort();
      initialized.delete(root);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yeefine-journal-post"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialized = new WeakSet();
    const initialize = () => {
      document.querySelectorAll('[data-yf-post]').forEach(root => {
        if (initialized.has(root)) return;
        initialized.add(root);
        const body = root.querySelector('[data-yf-post-body]');
        body.querySelectorAll('table').forEach(table => {
          const region = document.createElement('div');
          region.className = 'yf-post__table-scroll';
          region.tabIndex = 0;
          region.setAttribute('role','region');
          region.setAttribute('aria-label',body.dataset.tableLabel);
          table.before(region);
          region.append(table);
        });
        const toc = root.querySelector('[data-yf-post-toc]');
        const headings = [...body.querySelectorAll('h2,h3')];
        if (toc && headings.length > 2) {
          const list = toc.querySelector('ol');
          headings.forEach((heading,index) => {
            if (!heading.id) heading.id = 'journal-section-' + (index + 1);
            const item = document.createElement('li');
            if (heading.tagName === 'H3') item.className = 'yf-post__toc-sub';
            const link = document.createElement('a');
            link.href = '#' + heading.id;
            link.textContent = heading.textContent.trim();
            item.append(link);
            list.append(item);
          });
          toc.hidden = false;
        }
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initialize,{once:true});
    else initialize();
    document.addEventListener('shopify:section:load',initialize);
    window.addEventListener('pageshow',initialize);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yeefine-magazine"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialized = new WeakSet();
    const setup = () => {
      document.querySelectorAll('[data-yf-magazine]').forEach(root => {
        if (initialized.has(root)) return;
        const track = root.querySelector('[data-yf-recent-track]');
        if (!track) return;
        initialized.add(root);
        const previous = root.querySelector('[data-yf-recent-prev]');
        const next = root.querySelector('[data-yf-recent-next]');
        const update = () => {
          previous.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        };
        const move = direction => track.scrollBy({
          left: direction * (track.querySelector('article').getBoundingClientRect().width + 24),
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
        previous.addEventListener('click', () => move(-1));
        next.addEventListener('click', () => move(1));
        track.addEventListener('scroll', update, {passive:true});
        new ResizeObserver(update).observe(track);
        update();
      });
    };
    setup();
    document.addEventListener('shopify:section:load', setup);
  })();

  } catch(e) { console.error(e); }
})();
})();
